import React from "react";
import { ArrowDown, Sparkles } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1640357897497-599b4fc84f51?auto=format&fit=crop&w=1920&q=80";

const Hero = () => {
  const scrollToVisualize = () => {
    const el = document.getElementById("visualize");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen w-full overflow-hidden bg-[#0A0A0A] text-[#F7F5F0]"
      data-testid="hero-section"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Premium interior space"
          className="h-full w-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/85 via-[#0A0A0A]/50 to-[#0A0A0A]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/80 via-transparent to-transparent" />
      </div>

      {/* Grain overlay */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.07] mix-blend-overlay"
        style={{
          backgroundImage:
            "radial-gradient(rgba(255,255,255,1) 1px, transparent 1px)",
          backgroundSize: "3px 3px",
        }}
      />

      {/* Content */}
      <div className="relative z-10 mx-auto flex min-h-screen max-w-[1400px] flex-col justify-end px-6 pb-24 pt-40 md:px-12 md:pb-32">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:items-end">
          <div className="md:col-span-8">
            <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.32em] text-[#B8996F]">
              <Sparkles size={14} strokeWidth={1.6} />
              01 · Hubballi's Premium Interior Studio
            </div>
            <h1
              className="mt-6 font-[Cormorant_Garamond] text-5xl font-light leading-[0.96] tracking-tight text-[#F7F5F0] sm:text-6xl lg:text-[88px]"
              data-testid="hero-title"
            >
              Spaces that <span className="italic text-[#B8996F]">behave</span>
              <br />
              like architecture, not<br />
              decoration.
            </h1>
          </div>

          <div className="md:col-span-4 md:pl-6">
            <p className="font-[Outfit] text-base leading-relaxed text-white/70 md:text-lg" data-testid="hero-subtitle">
              Modular kitchens, bedroom wardrobes and turnkey interiors —
              designed in real time with you, built with material honesty.
            </p>

            <div className="mt-8 flex flex-col items-start gap-3 sm:flex-row">
              <button
                type="button"
                onClick={scrollToVisualize}
                data-testid="hero-cta-visualize"
                className="group inline-flex items-center gap-3 bg-[#B8996F] px-6 py-4 text-[11px] uppercase tracking-[0.24em] text-[#0A0A0A] transition-colors duration-300 hover:bg-[#F7F5F0]"
              >
                Start Visualizing
                <ArrowDown
                  size={14}
                  strokeWidth={2}
                  className="transition-transform duration-300 group-hover:translate-y-1"
                />
              </button>
              <button
                type="button"
                onClick={() => {
                  const el = document.getElementById("portfolio");
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
                data-testid="hero-cta-portfolio"
                className="border border-white/30 px-6 py-4 text-[11px] uppercase tracking-[0.24em] text-white/85 transition-colors duration-300 hover:border-white hover:text-white"
              >
                View Portfolio
              </button>
            </div>
          </div>
        </div>

        {/* Footer metrics row */}
        <div className="mt-16 grid grid-cols-2 gap-6 border-t border-white/10 pt-8 sm:grid-cols-4">
          {[
            ["12+", "Years Crafting Homes"],
            ["100+", "Karnataka Residences"],
            ["97%", "Repeat & Referral"],
            ["20 days", "Avg. Build Time"],
          ].map(([k, v]) => (
            <div key={v}>
              <div className="font-[Cormorant_Garamond] text-3xl text-[#F7F5F0]">{k}</div>
              <div className="mt-1 text-[10px] uppercase tracking-[0.24em] text-white/55">{v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
